import { useEffect, useState } from "react";
import { commonUrl, basePath } from '../api/config';
import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Player from '../../components/Player';
import Container from 'react-bootstrap/Container';
import SubHeader from '../../components/SubHeader';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import _ from "lodash";
import InnerHTML from 'dangerously-set-html-content'
import ArticleHeader from '../contentview/articleHeader';
import Head from 'next/head';

import styles from '../../styles/Contentview.module.css';




const ContentView = ({ dataID }) => {


    const [showSmHeader, setShowSmHeader] = useState(false);
    const [txtFontsize, setTxtFontsize] = useState(20);
    const [txtLineheight, setTxtLineheight] = useState(1.5);

    const postData = {
        id: dataID,
        title: "",
        count: "",
        post_date: "",
        disable_like: true
    }

    if (typeof window !== "undefined") {
        window.addEventListener("scroll", () =>
            setShowSmHeader(window.pageYOffset > 130)
        );
    }

    let loaderScript = `

      <style> title, viewcount, postdate { display:none; } </style>

      <div id='content_container'></div>
      <div id='message_invalid_page' style='display:none; font-size:18px; text-align:center; width:100%; padding:50px 0;'>頁面不存在</div>

      <script>
        function jQueryReady(callback) {
          if (window.jQuery == undefined) {
            setTimeout(function() {
              jQueryReady(callback);
            }, 30);
          } else {
            callback();
          }
        }

        function setPageTitle(title) {
          if (title != null) {
            $('#subHeader').text(title);
            $('.article_header_title').text(title);
            $('title').text(title + " - 錫安日報");
          }
        }

        function setViewCount(count) {
          if (count != null) {
            $('.article_header_count').text(count);
          }
        }

        function setPostDate(date) {
          if (date != null) {
            $('.article_header_post_date').text(date);
          }
        }

        jQueryReady(function() {

          let path    = window.location.pathname;
          let pageID  = path.split('/')[3];

          $.ajax({
            url      : "` + process.env.domain + `/3.0/page/" + pageID + (window.location.hostname == 'localhost' ? "/index.php" : "/") + window.location.search + window.location.hash,
            dataType : "text",
            cache    : (window.location.hostname != 'localhost')
          }).done(function( data ) {
            if (data != undefined) {
              $('#content_container').html(data);


              let title        = $('#content_container title').text();
              let view_count   = $('#content_container viewcount').text();
              let post_date    = $('#content_container postdate').text();

              $('#content_container title').remove();
              $('#content_container viewcount').remove();
              $('#content_container postdate').remove();

              setPageTitle(title);
              setViewCount(view_count);
              setPostDate(post_date);

            } else {
              $('#message_invalid_page').show();
            }
          }).fail(function() {
            $('#message_invalid_page').show();
          });


          $.ajax({ url : "https://asia-east2-ziondaily-web.cloudfunctions.net/zd30_api_increase_view_count/" + pageID});


        });

      </script>
    `;


    return (
        <>
            <Head>
                <title>錫安日報</title>
                <script src={`${process.env.domain}/3.0/page/js/jquery-3.6.0.min.js`}></script>
            </Head>
            <div>
                <Layout>
                    <Header />
                    <SubHeader isExternal={true} data="" />
                    <div className={showSmHeader ? styles.showSmHeader : styles.smHeader}>
                        <Container>{<ArticleHeader postData={postData} txtFontsize={txtFontsize} setTxtFontsize={setTxtFontsize} />}</Container>
                    </div>
                    <div className="viewport">
                        <div className="wrapper">
                            <ArticleHeader postData={postData} txtFontsize={txtFontsize} setTxtFontsize={setTxtFontsize} />
                            <Row>
                                <Col><div className={styles.headerDivider}></div></Col>
                            </Row>
                            <InnerHTML html={loaderScript} style={{ fontSize: txtFontsize }} />
                        </div>
                    </div>
                    <Footer />
                </Layout>
            </div>
        </>
    );

}

export default ContentView;